var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.65 24 24 18.65 24 12C24 5.34996 18.65 0 12 0C5.34996 0 0 5.34996 0 12C0 18.65 5.34996 24 12 24ZM15.3 13.8999C15.3 12.15 14.25 11.55 12.15 11.3C10.65 11.1 10.35 10.7 10.35 9.99995C10.35 9.29987 10.85 8.84999 11.85 8.84999C12.75 8.84999 13.25 9.14999 13.5 9.89999C13.55 10.05 13.7 10.1499 13.85 10.1499H14.65C14.85 10.1499 15 9.99994 15 9.80002V9.74999C14.8 8.64995 13.9 7.79998 12.75 7.70003V6.50002C12.75 6.29998 12.6 6.14998 12.35 6.09995H11.6C11.4 6.09995 11.25 6.24995 11.2 6.50002V7.64999C9.69996 7.85003 8.75004 8.84999 8.75004 10.1C8.75004 11.75 9.75 12.3999 11.85 12.65C13.25 12.9 13.7 13.2 13.7 14C13.7 14.8001 13 15.35 12.05 15.35C10.75 15.35 10.3 14.7999 10.15 14.0499C10.1 13.85 9.95004 13.7499 9.80004 13.7499H8.94996C8.75004 13.7499 8.60004 13.8999 8.60004 14.1V14.15C8.79996 15.3999 9.6 16.2999 11.25 16.55V17.75C11.25 17.9499 11.4 18.0999 11.65 18.15H12.4C12.6 18.15 12.75 18 12.8 17.75V16.55C14.3 16.2999 15.3 15.2499 15.3 13.8999ZM5.00004 9.54995C3.54996 13.4 5.55 17.75 9.45 19.15C9.6 19.25 9.75 19.4499 9.75 19.5999V20.3C9.75 20.4 9.75 20.45 9.69996 20.5C9.65004 20.7 9.45 20.7999 9.24996 20.7C6.45 19.8 4.29996 17.65 3.39996 14.85C1.89996 10.1 4.5 5.04995 9.24996 3.54995C9.3 3.50003 9.39996 3.50003 9.45 3.50003C9.65004 3.54995 9.75 3.69995 9.75 3.89999V4.59995C9.75 4.85003 9.65004 5.00003 9.45 5.09999C7.40004 5.84999 5.75004 7.44995 5.00004 9.54995ZM14.3 3.74999C14.35 3.54995 14.55 3.44999 14.75 3.54995C17.5 4.44995 19.7 6.59999 20.6 9.44999C22.1 14.2 19.5 19.25 14.75 20.75C14.7 20.8 14.6 20.7999 14.55 20.7999C14.35 20.75 14.25 20.6 14.25 20.4V19.7C14.25 19.45 14.35 19.2999 14.55 19.2C16.6 18.45 18.25 16.85 19 14.75C20.45 10.9 18.45 6.54995 14.55 5.15003C14.4 5.04995 14.25 4.85003 14.25 4.64999V3.95003C14.25 3.84995 14.25 3.80003 14.3 3.74999Z",
    fill: "url(#paint0_linear_163_698)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_698",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5263B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B266F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.08101e0631aba42479127865477e072c.svg";
export { ForwardRef as ReactComponent };